import { render, staticRenderFns } from "./RegisterMultipleBuildingsProjectBox.vue?vue&type=template&id=1c0ed95e"
import script from "./RegisterMultipleBuildingsProjectBox.vue?vue&type=script&lang=js"
export * from "./RegisterMultipleBuildingsProjectBox.vue?vue&type=script&lang=js"
import style0 from "./RegisterMultipleBuildingsProjectBox.vue?vue&type=style&index=0&id=1c0ed95e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports